import {Box, Button, Grid, MenuItem, Stack, TextField, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import ApiService from "../services/ApiService";
import {NumericFormat} from "react-number-format";

export default function EditStock() {
    const navigate = useNavigate();
    const path = useLocation();
    const id = path.pathname.split('/')[2];
    const stockId = path.pathname.split('/')[3];

    const [description, setDescription] = useState(undefined);
    const [type, setType] = useState(undefined);
    const [quantity, setQuantity] = useState(undefined);
    const [supplier, setSupplier] = useState(undefined);
    const [notes, setNotes] = useState(undefined);
    const [isEdit, setIsEdit] = useState(stockId !== 'new');

    useEffect(() => {
        if (stockId !== 'new') {
            ApiService.getStockByStockId(stockId).then(response => response.json()).then(response => {
                const stock = response;
                setType(stock.status);
                setQuantity(Number(stock.quantity));
                setSupplier(stock.supplier);
                setNotes(stock.notes);
                setDescription(stock.description);
            })
        } else {
            setIsEdit(false);
        }
    }, [stockId]);

    function saveStock() {
        if (stockId !== 'new') {
            const body = {
                id: stockId,
                description: description,
                quantity: quantity,
                supplier: supplier,
                notes: notes
            }

            ApiService.updateStock(body).then(response => response.json()).then(response => {
                if (response) {
                    navigate("/product-details/" + id);
                }
            })
        } else {
            const body = {
                description: description,
                quantity: quantity,
                supplier: supplier,
                notes: notes,
                stockLineType: type,
                productId: id
            }

            ApiService.createStock(body).then(response => response.json()).then(response => {
                if (response) {
                    navigate("/product-details/" + id);
                }
            })
        }
    }

    function checkMandatoryStockFields() {
        return !(type && quantity && supplier);
    }

    function getLabel() {
        let label = '';
        if (isEdit) {
            if (type === 'SUPPLY') {
                label = 'Entrata Merci';
            } else {
                label = 'Correzione dello stock';
            }
        } else {
            label = 'Seleziona tipo di fornitura';
        }
        return label;
    }

    return (<>
        <Grid container sx={{marginTop: 2}}>
            <Grid item xs={12}>
                <Breadcrumb/>
                <Typography variant="h5" component="h2"
                            sx={{fontWeight: '500'}}>{isEdit ? 'Modifica Fornitura' : 'Nuova Fornitura'}</Typography>
            </Grid>
        </Grid>
        <Grid container sx={{mt: 4}}>
            <Grid item xs={12} md={4}>
                <Box component={'form'}>
                    <Stack spacing={1.5}>

                        {type === 'SUPPLY' ?
                            <TextField
                                select
                                disabled={isEdit}
                                id="type"
                                value={type || ''}
                                label={getLabel()}
                                onChange={e => setType(e.target.value)}
                                required
                                variant={'standard'}
                                fullWidth
                            >
                                <MenuItem key={'supply'} value={'SUPPLY'}>Entrata merci</MenuItem>
                                <MenuItem key={'removal'} value={'REMOVAL'}>Correzione dello stock</MenuItem>
                            </TextField>
                            :
                            <TextField
                                select
                                disabled={isEdit}
                                id="type"
                                defaultValue={type}
                                value={type}
                                label={type ? 'REMOVAL' : 'Seleziona tipo di fornitura'}
                                onChange={e => setType(e.target.value)}
                                required
                                variant={'standard'}
                                fullWidth
                            >
                                <MenuItem key={'supply'} value={'SUPPLY'}>Entrata merci</MenuItem>
                                <MenuItem key={'removal'} value={'REMOVAL'}>Correzione dello stock</MenuItem>
                            </TextField>
                        }

                        <TextField id="description" label="Descrizione" value={description}
                                   defaultValue={description} variant="standard" fullWidth
                                   InputLabelProps={isEdit ? {shrink: true} : ''}
                                   onChange={e => setDescription(e.target.value)}/>
                        <TextField id="supplier" label="Fornitore" value={supplier} defaultValue={supplier}
                                   InputLabelProps={isEdit ? {shrink: true} : ''} fullWidth
                                   variant="standard"
                                   onChange={e => setSupplier(e.target.value)} required/>
                        <NumericFormat
                            allowNegative={false}
                            decimalScale={0}
                            customInput={TextField} id="quantity"
                            label="Quantità"
                            defaultValue={quantity}
                            value={quantity}
                            variant="standard"
                            required
                            onChange={e => setQuantity(e.target.value)}
                            fullWidth/>
                        <TextField
                            id="notes"
                            label="Note"
                            defaultValue={notes}
                            value={notes}
                            variant="standard"
                            onChange={e => setNotes(e.target.value)}
                            InputLabelProps={isEdit ? {shrink: true} : ''}
                            multiline
                            rows={5}
                            fullWidth
                        />
                    </Stack>
                </Box>
                <Grid container sx={{mt: 3}} justifyContent={'space-between'}>
                    <Grid item>
                        <Button variant="flip" onClick={() => {
                            navigate('/product-details/' + id)
                        }}>
                            Annulla
                        </Button>

                    </Grid>
                    <Grid item>
                        {isEdit ?
                            <Button variant="contained" color="primary" disabled={checkMandatoryStockFields()}
                                    onClick={() => {
                                        saveStock()
                                    }}>Salva</Button>
                            :
                            <Button variant="contained" color="primary" disabled={checkMandatoryStockFields()}
                                    onClick={() => {
                                        saveStock()
                                    }}>Crea</Button>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Grid>

    </>);
}